module.exports = __webpack_public_path__ + "media/images/app-reorder-screen-dc894dc63163e44a9e21187b61b4626c.png";